import { render, staticRenderFns } from "./ResetPwd.vue?vue&type=template&id=fc1396c0&scoped=true"
import script from "./ResetPwd.vue?vue&type=script&lang=js"
export * from "./ResetPwd.vue?vue&type=script&lang=js"
import style0 from "./ResetPwd.vue?vue&type=style&index=0&id=fc1396c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1396c0",
  null
  
)

export default component.exports